
















import { defineComponent, ref, Ref }  from '@vue/composition-api';
import cLoginForm                     from '@/views/login/components/login-form/login-form.component.vue';
import cProRms                        from '@/components/logo/pro-rms/pro-rms.component.vue';
import { GlobalContexts, useGlobals } from '@/hooks/use-globals';
import useCookiePolicyHook            from '@/views/cookie-policy/hooks/use-cookie-policy.hook';
import { RouteParams }                from '@/router/router.types';

export default defineComponent({
  name: 'cLoginFormWrapper',
  components: {
    cProRms,
    cLoginForm,
  },
  setup() {
    const { i18n, store }: GlobalContexts = useGlobals();
    const { cookiePolicy }: { cookiePolicy: RouteParams } = useCookiePolicyHook();

    const brandName: Ref<string> = ref(i18n.t(`${store.state.i18n.GLOBAL_PATH}.brand`)
      .toString());

    const subtitleTranslation: Ref<string> = ref(i18n.t('vLogin.form.subtitle')
      .toString());

    const termsOfUseTranslation: Ref<string> = ref(i18n.t('vLogin.termsOfUse')
      .toString());

    return {
      i18n,
      brandName,
      cookiePolicy,
      subtitleTranslation,
      termsOfUseTranslation,
    };
  },
});
